import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 35 35"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "#FFF",
      "stroke-width": "1.167",
      transform: "translate(0 -.952)"
    }, [
      _createElementVNode("path", { d: "M18.222 27.718c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.478-10 10c0 1.6.376 3.112 1.044 4.453.177.356.236.763.133 1.148l-.595 2.226a1.3 1.3 0 0 0 1.592 1.592l2.226-.596a1.63 1.63 0 0 1 1.148.134 9.96 9.96 0 0 0 4.452 1.043Z" }),
      _createElementVNode("path", {
        "stroke-linecap": "round",
        d: "M13.004 14.951c-.048 1.297.274 3.5 2.441 5.709A9.5 9.5 0 0 0 17 21.95m-3-9.355c.963-.958 2.5-.83 3.111.26l.45.8c.404.721.242 1.668-.396 2.302q0 0 0 0s-.774.77.629 2.164c1.402 1.394 2.176.626 2.176.626q0 0 0 0c.638-.635 1.59-.796 2.316-.394l.804.447c1.096.608 1.225 2.136.262 3.093-.579.576-1.288 1.023-2.072 1.053a6.8 6.8 0 0 1-2.12-.263"
      }),
      _createElementVNode("rect", {
        width: "33.833",
        height: "33.785",
        x: ".583",
        y: "1.583",
        rx: "15.556"
      })
    ], -1)
  ]))]))
}
export default { render: render }